// import dotProp from './node_modules/dot-prop-immutable'
import {
  PAYMENT_PAYFORU_SUCCESS,
  CLEAR_QRCODE_SUCCESS,
  LOAD_PAYMENT_STATUS_SUCCESS,
  NOT_AUTHEN,
} from './action'
const initialPagesState = {

  qrCodePayment: '',
  qrCodeAmount: 0,
  refId: '',
  paymentStatus: [],
  auth: true,
}

const payment = (state = initialPagesState, action) => {
  switch (action.type) {
    case PAYMENT_PAYFORU_SUCCESS:
      return {
        ...state,
        qrCodePayment: action.data.qrcode_text,
        qrCodeAmount: action.data.amount,
        refId: action.data.refId,
      }
    case CLEAR_QRCODE_SUCCESS: {
      return {
        ...state,
        qrCodePayment: initialPagesState.qrCodePayment,
        qrCodeAmount: initialPagesState.qrCodeAmount,
        refId: initialPagesState.refId,
      }
    }
    case LOAD_PAYMENT_STATUS_SUCCESS:
      {
        return {
          ...state,
          paymentStatus: [
            ...action.payload,
          ]
        }
      }
    case NOT_AUTHEN:
      {
        return {
          ...state,
          auth: false,
        }
      }
    default:
      return state
  }
}

export default payment



// WEBPACK FOOTER //
// ./src/components/Payment/reducer.js